import React from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useDispatch, useSelector } from "react-redux";
import { auth, db, functions } from "firebaseApp";
import { imageEditorActions } from "store/imageEditor";
import { httpsCallable } from "firebase/functions";
import { addDoc, collection } from "firebase/firestore";
import { Button, CircularProgress } from "@mui/material";
import { invertMask } from "./InvertMaskButton";

export default function EditImageButton({ editorRef }) {
  const dispatch = useDispatch();
  const uid = auth .currentUser?.uid;

  const imageEditorState = useSelector((state) => state.imageEditor);
  const processing = imageEditorState.processing;
  const prompt = imageEditorState.prompt;
  const ratio = imageEditorState.ratio;
  const image = imageEditorState.image;
  const imageStudioState = useSelector((state) => state.imageStudio);


  const editImage = async () => {
    try {
      dispatch(imageEditorActions.setProcessing(true));
      const base64Image = imageEditorState.image;
      // The open AI API edits transparent parts of the image so we need to invert the mask
      const base64Mask = await invertMask(imageEditorState.mask);
      const response = await httpsCallable(
        functions,
        "uploadBase64Images"
      )({
        images: [base64Image, base64Mask],
      });
      const [image, mask] = response.data.images;
      const payload = {
        uid,
        prompt,
        images: [image],
        mask,
        ratio,
        generating: true,
        createdAt: new Date().getTime(),
        //modelName: imageStudioState.model.name,
        modelName: "gpt-image-1",
      };
      console.log(payload);
      await addDoc(collection(db, "imageGeneration"), payload);
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(imageEditorActions.setProcessing(false));
    }
  };

  const canGenerate = () => {
    if (processing) return false;
    if (!prompt) return false;
    if (!image) return false;
    return true;
  };

  return (
    <Button
      startIcon={<AutoAwesomeIcon />}
      variant="contained"
      disabled={!canGenerate()}
      onClick={editImage}
    >
      {processing ? <CircularProgress size={24} /> : "Generate"}
    </Button>
  );
}
